import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Field = styled.div`
  font-family: 'Roboto';
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 5px;
`
export const Value = styled.div`
  font-family: 'Roboto';
  font-style: bold;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 20px;
`
export const DadosMotorista = styled.div`
  width: 100%;
  margin-bottom: 40px;
`
export const Title = styled.div`
  font-family: 'Roboto';
  font-style: italic;
  font-size: 16px;
  font-weight: 700;
  color: ${colors.green};
  margin-bottom: 20px;
`
